import React from "react";
import {Modal} from "antd";

export const AccountApprovalModal = ({
    visible,
    onConfirm,
    onCancel,
    selectedOrdersCount,
    loading
}) => {
    return (
        <Modal
            title="İşlemi Onaylıyor musunuz?"
            visible={visible}
            onOk={onConfirm}
            onCancel={onCancel}
            okText="Hesap Al"
            cancelText="Vazgeç"
            okButtonProps={{
                style: {
                    backgroundColor: "#AEF001",
                    borderColor: "#AEF001",
                    color: "#000"
                }
            }}
            confirmLoading={loading}
            centered
            style={{top: 20}}
        >
            <p>
                Seçilen {selectedOrdersCount} siparişin hesabını almak istediğinizden emin misiniz?
            </p>
        </Modal>
    );
};
